import { render, staticRenderFns } from "./ChooseCompany.vue?vue&type=template&id=681faf67&"
import script from "./ChooseCompany.vue?vue&type=script&lang=js&"
export * from "./ChooseCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports